// #VENDOR_ALIAS_V1 (2026-10-20) — Bill: "AP having the same issue... ideally I would like to pull a spend
// report and see where the money is going." Same non-destructive pattern as customerAlias.js: Supabase key
// `vendor-alias` = { [normalizedRawName]: canonicalName }. Spend rollups resolve supplier names through it,
// so Ditchwitch / Ditch Witch / DITCH WITCH (bankcard) land on one row. A name with no entry still folds
// with any other spelling that differs only by case / spaces / punctuation ("Tractor supply" = "TRACTOR SUPPLY").
export const VENDOR_ALIAS_KEY = 'vendor-alias';
export const normVendKey = (s) => String(s || '').trim().replace(/\s+/g, ' ').toUpperCase();
const loose = (s) => String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
const _idx = new WeakMap();
const idxFor = (map) => {
  let m = _idx.get(map); if (m) return m;
  m = new Map();
  Object.values(map).forEach(c => { const k = loose(c); if (k && !m.has(k)) m.set(k, c); });
  Object.entries(map).forEach(([k, c]) => { const kk = loose(k); if (kk && !m.has(kk)) m.set(kk, c); });
  _idx.set(map, m); return m;
};
export const resolveVendor = (map, raw) => {
  const r = String(raw || '').trim(); if (!r || !map || typeof map !== 'object') return r;
  return map[normVendKey(r)] || idxFor(map).get(loose(r)) || r;
};
// For a set of rows: resolve through the map, then fold leftover case/punctuation twins onto the most-used spelling.
export const vendorFolder = (map, names) => {
  const cnt = new Map();   // loose -> Map(spelling -> count)
  names.forEach(n => { const c = resolveVendor(map, n); if (!c) return; const k = loose(c); if (!cnt.has(k)) cnt.set(k, new Map()); const s = cnt.get(k); s.set(c, (s.get(c) || 0) + 1); });
  const pick = new Map();
  cnt.forEach((s, k) => { const mapped = new Set(Object.values(map || {})); const best = [...s.entries()].sort((a, b) => (mapped.has(b[0]) - mapped.has(a[0])) || (b[1] - a[1]))[0][0]; pick.set(k, best); });
  return (n) => { const c = resolveVendor(map, n); return c ? (pick.get(loose(c)) || c) : ''; };
};
